import dayjs from "dayjs";
import styles from "styles/pages/reports/reports.module.scss";
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useEffect, useState } from "react";
import { If } from "shared/components/control-statements";
dayjs.extend(utc);
dayjs.extend(localizedFormat);
dayjs.locale("pt-br");

export default function Filters({ filters = {}, onRemoveFilter, units = [] }) {
  const [showCloseDateFilters, setShowCloseDateFilter] = useState(true);
  const [display, setDisplay] = useState("");

  const renderItem = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return null;
    if (arr.length <= 2) return arr.join(", ");
    const visible = arr.slice(0, 2).join(", ");
    const moreCount = arr.length - 2;
    return (
      <>
        {visible} <span className={styles.more}>+{moreCount}</span>
      </>
    );
  };

  const namedUnits = filters.unit_id?.map((id) =>
    (units || []).get(`units_${id}`)
  );

  const startDate = dayjs.utc(filters?.start_date);
  const endDate = dayjs.utc(filters?.end_date);

  const fullMonthStart = startDate.startOf("month");
  const fullMonthEnd = startDate.endOf("month");

  useEffect(() => {
    if (
      !filters?.start_date &&
      !filters?.end_date &&
      filters.period !== "FROM_THE_BEGINNING"
    ) {
      setDisplay(dayjs().format("MMMM [de] YYYY"));
      setShowCloseDateFilter(false);
      return;
    }

    if (
      startDate.isSame(fullMonthStart, "day") &&
      endDate.isSame(fullMonthEnd, "day")
    ) {
      setDisplay(startDate.format("MMMM [de] YYYY"));
    } else {
      setDisplay(
        `${startDate.format("DD/MM/YYYY HH:mm")} - ${endDate.format(
          "DD/MM/YYYY HH:mm"
        )}`
      );
    }

    setShowCloseDateFilter(true);
  }, [filters, startDate, endDate, fullMonthStart, fullMonthEnd]);

  return (
    <ul className={styles.containerFilters}>
      <li className={styles.filter}>
        <span className={styles.label}>Período:</span>
        <If cond={filters.period === "FROM_BEGGINING"}>
          <span className={styles.value}>Todos</span>
        </If>
        <If cond={filters.period === "FROM_THE_BEGINNING"}>Desde o início</If>
        <If cond={filters.period !== "FROM_THE_BEGINNING"}>
          <span className={styles.value}>{display}</span>
        </If>

        <If cond={showCloseDateFilters}>
          <span
            className={styles.remove}
            onClick={() => onRemoveFilter("date")}
          >
            <i className="fal fa-times" />
          </span>
        </If>
      </li>

      {namedUnits && namedUnits.length > 0 && (
        <li className={styles.filter}>
          <span className={styles.label}>Unidade:</span>
          <span className={styles.value}>{renderItem(namedUnits)}</span>

          <span
            className={styles.remove}
            onClick={() => onRemoveFilter("units")}
          >
            <i className="fal fa-times" />
          </span>
        </li>
      )}

      {filters.origin && filters.origin.length > 0 && (
        <li className={styles.filter}>
          <span className={styles.label}>Origem:</span>
          <span className={styles.value}>{renderItem(filters.origin)}</span>

          <span
            className={styles.remove}
            onClick={() => onRemoveFilter("origins")}
          >
            <i className="fal fa-times" />
          </span>
        </li>
      )}

      {filters.coupon_id && filters.coupon_id.length > 0 && (
        <li className={styles.filter}>
          <span className={styles.label}>Cupons:</span>
          <span className={styles.value}>{filters.coupon_id.length}</span>

          <span
            className={styles.remove}
            onClick={() => onRemoveFilter("coupons")}
          >
            <i className="fal fa-times" />
          </span>
        </li>
      )}
    </ul>
  );
}
